<template>
  <rpm-table
    title="Serviços Duplicados"
    :pagination="pagination"
    @change-page="getDuplicatedServices"
    :data="duplicateServices"
    :loading="listLoading"
    :columns="[
      {
        field: 'source_service',
        label: 'Serviço',
      },
      {
        field: 'service_count',
        label: 'Quantidade',
      },
      
      {
        field: 'neighborhood_name',
        label: 'Bairro',
      },
      {
        field: 'address',
        label: 'Rua',
      },
    ]"
  >
    <template #actions="{item}">
      <rpm-button
        icon="fa-solid fa-arrows-to-circle"
        tooltip-text="agrupar"
        color="transparent"
        @click="selectedDuplicateServicesArray = item.services, openModal(item)"
      ></rpm-button>
    </template>
  </rpm-table>

  <rpm-modal
    :open="modalOpen"
    @close="closeModal()"
    class="flex flex-col gap-2"
    header="Agrupar Serviços"
    persist
  >
    <rpm-table
      no-card
      title="Serviços"
      title-class="text-md font-semibold whitespace-nowrap"
      title-container-class="flex flex-row items-center"
      :data="inspectedDuplicateServices"
      :columns="[
        {
          field: 'check',
          label: '',
        },
        {
          field: 'id',
          label: 'Serviço',
        },
        {
          field: 'person.name',
          label: 'Solicitante',
        },
        {
          field: 'started_at',
          label: 'Data da Solicitação',
        },
        {
          field: 'procedures[0].source_procedure.name',
          label: 'Procedimento atual',
        }
      ]"
    >
      <template #cell:started_at="{item}">
        <div class="px-2 text-xs">
          {{ formatDate(item, 'DD/MM/YYYY HH:mm') }}
        </div>
      </template>

      <template #header:check>
        <rpm-input
          type="checkbox"
          class="my-2"
          v-model="selectAll"
        ></rpm-input>
      </template>

      <template #cell:check="{item}">
        <rpm-input
          type="checkbox"
          v-model="selectedDuplicateServicesObject[item.id]"
        ></rpm-input>
      </template>
    </rpm-table>

    <rpm-input
      type="textarea"
      label="Observações"
      optional
      v-model="form.observation"
    ></rpm-input>

    <div class="flex flex-row justify-center gap-6 mt-4">
      <rpm-button
        @click="modalOpen = false"
        color="gray"
        label="Fechar"
      ></rpm-button>

      <rpm-button
        label="Agrupar"
        color="theme"
        @click="grouping"
        :loading="loading"
      ></rpm-button>
    </div>
  </rpm-modal>
</template>

<script>
import RpmTable from "#components/RpmTable.vue";
import RpmModal from "#components/RpmModal.vue";

import {formatDate} from "#functions/formatter.js";
import _ from "lodash";

import serviceRepository from "#repositories/serviceRepository";
import servicesGroupsRepository from "#repositories/servicesGroupsRepository";
import {request} from "#repositories/repository";

export default {
  name: 'ServicesGroup',
  components: {
    RpmTable,
    RpmModal
  },
  data() {
    return {
      duplicateServices: [],
      inspectedDuplicateServices: [],
      selectedDuplicateServicesArray: [],
      selectedDuplicateServicesObject: {},
      modalOpen: false,
      listLoading: false,
      pagination: {
        page: this.$route.query.page ?? 1,
        per_page: 12,
        last_page: 0,
        links: []
      },
      form: {},
      loading: false,
      groupedItems: null,
      selectAll: false,
    }
  },
  methods: {
    formatDate(...params){
      return formatDate(...params);
    },
    async getDuplicatedServices(page = 0) {
      if (!isNaN(page) && 0 != page) this.pagination.page = page;

      this.listLoading = true;
      this.duplicateServices = request.pagination(
          await serviceRepository.fetchDuplicatedServices(this.pagination),
          this.pagination
      );
      this.listLoading = false;
    },
    async grouping() {
      this.form.checked_services = _.keys(_.omitBy(this.selectedDuplicateServicesObject, (val) => !val));
      this.loading = true
      try {
        let response = (await servicesGroupsRepository.storeServicesGroup(this.form)).data
        this.modalOpen = false
        this.$notify('Serviços agrupados com sucesso.', 'success')
        this.form.observation = ''
        this.getDuplicatedServices();

      } catch (errors) {
        this.$notify((_.pick(errors.errors, 'checked_services')).checked_services[0], 'error')
      } finally {
        this.loading = false
      }

    },
    async openModal(item) {
      this.modalOpen = true;
      if (item.group_id) {
        this.groupedItems = (await servicesGroupsRepository.fetchServicesGroup({
          group_id: item.group_id
        })).data.items
      }
    },
    closeModal() {
      this.modalOpen = false;
      this.selectAll = false;
    }
  },
  watch: {
    async selectedDuplicateServicesArray(newer) {
      this.inspectedDuplicateServices = [];
      this.selectedDuplicateServicesObject = {};

      this.inspectedDuplicateServices = (await serviceRepository.showDuplicatedServices({
        checked_services: newer
      })).data
    },
    inspectedDuplicateServices(val) {
      if (this.groupedItems && val) {
        this.inspectedDuplicateServices = _.differenceBy(this.inspectedDuplicateServices, this.groupedItems, 'id_number')
      }
    },
    selectAll(bool){
      this.inspectedDuplicateServices.forEach(service => {
        this.selectedDuplicateServicesObject[service.id] = bool;
      });
    }
  },
  mounted() {
    this.getDuplicatedServices();
  },
}
</script>